<!-- 主体轮播图 -->
<template>
  <div class="carousel">
    <swiper ref="mySwiper" :options="swiperOptions">
      <swiper-slide v-for="(item, index) in banners" :key="index">
        <img
          class="swiper-img"
          :src="item.src"
          alt="图片"
          @click="jumpDn(item.id)"
        />
        <div class="img-div">
          <p class="img-title">{{ item.title }}</p>
        </div>
      </swiper-slide>

      <div class="swiper-pagination" slot="pagination"></div>
    </swiper>

    <!-- <p class="img-title">999</p> -->
  </div>
</template>

<script>
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import { getArticleList } from "@/api/home";
import { getActive, setActive, removeActive } from "@/utils/auth";
import "swiper/css/swiper.css";

export default {
  name: "CarouselChild",
  //import引入的组件需要注入到对象中才能使用
  components: {
    Swiper,
    SwiperSlide,
  },
  data() {
    //这里存放数据
    return {
      writeList: [{}, {}, {}],
      banners: [],
      swiperOptions: {
        loop: true,
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
          paginationClickable: true,
        },
        slidesPerView: 1,
        spaceBetween: 30,
        autoplay: {
          delay: 3000,
          disableOnInteraction: false,
        },
      },
    };
  },
  //监听属性 类似于data概念
  computed: {
    swiper() {
      return this.$refs.mySwiper.$swiper;
    },
  },
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    jumpDn(id) {
      this.$router.push({
        path: "/newsdetail",
        query: {
          id: id,
        },
      });
      setActive("3");
      this.$store.dispatch("user/setActive", "3");
    },
    fetchData() {
      let params1 = {
        page: 1,
        type: 1,
      };
      getArticleList(params1).then((response) => {
        this.writeList = response.data;
        this.banners = response.data.filter((item) => item.img != "");
        this.banners = this.banners.map((item) => {
          return { src: item.img, id: item.id, title: item.title };
        });
      });
    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.fetchData();
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    this.swiper.slideTo(3, 1000, false);
  },
};
</script>
<style lang="scss" scoped>
.carousel {
  width: 100%;
  height: 100%;
  position: relative;
  z-index: 1;
  .swiper-wrapper {
    position: relative;
    z-index: 1;
  }
  .swiper-container {
    height: 100%;
    width: 100%;
    top: 0;
    left: 0;
    position: absolute;
    z-index: 1;
  }
  .swiper-img {
    width: 100%;
    height: 100%;
    cursor: pointer;
  }
  .swiper-slide {
    position: relative;
    z-index: 1;
  }
  .img-div {
    width: 100%;
    height: 30px;
    position: absolute;
    bottom: 0px;
    background-color: #293855;
    opacity: 0.8;
  }
  .img-title {
    margin: 0;
    position: absolute;
    color: #ffffff;
    opacity: 1;
    z-index: 1000;
    bottom: 8px;
    left: 10px;
    max-width: 250px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .swiper-pagination {
    width: 100%;
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    text-align: right;
    color: #ffffff;
    padding-right: 10px;
    position: absolute;
    bottom: 0px;
    .swiperPag {
      width: 120px !important;
      height: 30px !important;
      display: flex;
      align-items: center;
      margin: 0 auto;
      background-color: rgba($color: #000000, $alpha: 0.8);
    }
  }

  .swiper-pagination-customs {
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background-color: #ffffff;
    display: inline-block;
  }
  /*自定义分页器激活时的样式表现*/
  .swiper-pagination-customs-active {
    width: 10px;
    height: 10px;
    display: inline-block;
    border-radius: 50%;
    background-color: #28a7e1;
  }
}
</style>
